<script>
  
  export default {
    components: {  },
    props: {
      pedidos: {
        required: true
      },
    },
    data() {
      return {
        salvandoLiberacao: false,
        animated: false,
      }
    },
    methods: {
      lista(pagina = 1) {
        this.pedidos.pagina = pagina;

        this.$emit('lista');
      },
    },
  }
</script>

<template>
  <div class="group">
    <h4 class="text-center">Sem pedidos de compra para liberação</h4>

    <div class="hr-line-dashed margin-top-5"></div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/liberar-pedidos-compras/componentes/compartilhado/LiberarPedidoSemLista.vue